



































































































































import { Component, Emit, Vue } from 'vue-property-decorator'

@Component
export default class Error409Modal extends Vue {
  private closeModal () {
    this.$emit('close-modal')
  }
  private doReload () {
    window.location.reload()
  }
}
